import FilterPopup from './brand-venues/Popups/FilterPopup';
import CardPopup from './brand-venues/Popups/CardPopup';

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    // Initialize all brand-venues components on the page
    const brandVenuesBlock = document.querySelector('.venue-details');
    if (brandVenuesBlock) {
      // eslint-disable-next-line no-new
      new FilterPopup(brandVenuesBlock);

      // eslint-disable-next-line no-new
      new CardPopup(brandVenuesBlock);
    }
  }, 0);
});
